export { OfferChangeNotificationWithTranslation as OfferChangeNotification } from './OfferChangeNotification';
